import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Auth } from '@core/services/auth';
import { catchError, throwError } from 'rxjs';

/**
 * Interceptor para manejar errores de autenticación
 * Redirige al login cuando el token expira (401/403)
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const auth = inject(Auth);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Si es un error de autenticación (token expirado o inválido)
      if (error.status === 401 || error.status === 403) {
        // Limpiar sesión y redirigir al login
        auth.signOut().then(() => {
          router.navigate(['/welcome']);
        });
      }

      return throwError(() => error);
    })
  );
};
